<template>
  <footer class="bg-white border-t border-neutral-100">
    <div class="container mx-auto xs:px-4">
      <div class="grid grid-cols-3 mt-[80px] xs:mt-[40px] gap-3 xs:gap-8 xs:grid-cols-1">
        <!-- Company info -->
        <div class="col-span-1">
          <img
            class="object-contain w-52"
            src="/img/logo-assets/rintisanBusiness.png"
            alt="Rintisan Business"
          >
          <p class="text-base mt-8 text-neutral-800 leading-relaxed font-geist-mono">
            <span class="font-bold font-geist-mono">PT Rintisan Teknologi Waralaba</span><br>
            Holland Village Office Tower <br>
            Jl. Letjen Suprapto, Kav.60 No.1,<br>
            Central Jakarta 10510
          </p>
          <div class="mt-10">
            <p class="text-base text-neutral-800 font-geist-mono">
              Terdaftar di
            </p>
            <div class="flex gap-3 mt-3">
              <img class="w-[70px] object-contain" src="/img/logo-assets/PSELogo.png" alt="PSE">
              <img class="w-[70px] object-contain" src="/img/logo-assets/ASPILogo.png" alt="ASPI">
            </div>
          </div>
        </div>

        <!-- Links & contact -->
        <div class="col-span-2 xs:col-span-1">
          <div class="flex xs:flex-col gap-[64px] xs:gap-8">
            <!-- Tentang Rintisan -->
            <div>
              <h3 class="mb-4 text-xl font-bold text-neutral-800 font-geist">
                Tentang Rintisan
              </h3>
              <ul>
                <li class="mb-3">
                  <a
                    href="https://billing.rintisan.co.id/kebijakan-privasi"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-base text-neutral-800 hover:text-neutral-600 transition-colors font-geist-mono"
                  >
                    Apa itu Rintisan?
                  </a>
                </li>
                <li class="mb-3">
                  <a
                    href="https://billing.rintisan.co.id/tentang-rintisan"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-base text-neutral-800 hover:text-neutral-600 transition-colors font-geist-mono"
                  >
                    Syarat &amp; Ketentuan
                  </a>
                </li>
                <li class="mb-3">
                  <a
                    href="https://billing.rintisan.co.id/tentang-rintisan"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-base text-neutral-800 hover:text-neutral-600 transition-colors font-geist-mono"
                  >
                    Kebijakan Privasi
                  </a>
                </li>
              </ul>
            </div>

            <!-- Customer Support -->
            <div>
              <h3 class="mb-4 text-xl font-bold text-neutral-800 font-geist">
                Costumer Support
              </h3>
              <ul>
                <li class="flex items-center gap-3 mb-4 text-base text-neutral-800 font-geist-mono">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM17.47 9.59L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L16.53 8.41C16.85 8.15 17.33 8.2 17.58 8.53C17.84 8.85 17.79 9.33 17.47 9.59Z" fill="currentColor" />
                  </svg>
                  support@rintisan.co.id
                </li>
                <li class="mb-4">
                  <a
                    href="https://wa.link/7hq1il"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="flex items-center gap-3 text-base text-neutral-800 hover:text-neutral-600 transition-colors font-geist-mono"
                  >
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.55 14.95L9.7 16.8C9.31 17.19 8.69 17.19 8.29 16.81C8.18 16.7 8.07 16.6 7.96 16.49C6.93 15.45 6 14.36 5.17 13.22C4.35 12.08 3.69 10.94 3.21 9.81C2.74 8.67 2.5 7.58 2.5 6.54C2.5 5.86 2.62 5.21 2.86 4.61C3.1 4 3.48 3.44 4.01 2.94C4.65 2.31 5.35 2 6.09 2C6.37 2 6.65 2.06 6.9 2.18C7.16 2.3 7.39 2.48 7.57 2.74L9.89 6.01C10.07 6.26 10.2 6.49 10.29 6.71C10.38 6.92 10.43 7.13 10.43 7.32C10.43 7.56 10.36 7.8 10.22 8.03C10.09 8.26 9.9 8.5 9.66 8.74L8.9 9.53C8.79 9.64 8.74 9.77 8.74 9.93C8.74 10.01 8.75 10.08 8.77 10.16C8.8 10.24 8.83 10.3 8.85 10.36C9.03 10.69 9.34 11.12 9.78 11.64C10.23 12.16 10.71 12.69 11.23 13.22C11.33 13.32 11.44 13.42 11.54 13.52C11.94 13.91 11.95 14.55 11.55 14.95Z" fill="currentColor" />
                      <path d="M22.4696 18.33C22.4696 18.61 22.4196 18.9 22.3196 19.18C22.2896 19.26 22.2596 19.34 22.2196 19.42C22.0496 19.78 21.8296 20.12 21.5396 20.44C21.0496 20.98 20.5096 21.37 19.8996 21.62C19.8896 21.62 19.8796 21.63 19.8696 21.63C19.2796 21.87 18.6396 22 17.9496 22C16.9296 22 15.8396 21.76 14.6896 21.27C13.5396 20.78 12.3896 20.12 11.2496 19.29C10.8596 19 10.4696 18.71 10.0996 18.4L13.3696 15.13C13.6496 15.34 13.8996 15.5 14.1096 15.61C14.1596 15.63 14.2196 15.66 14.2896 15.69C14.3696 15.72 14.4496 15.73 14.5396 15.73C14.7096 15.73 14.8396 15.67 14.9496 15.56L15.7096 14.81C15.9596 14.56 16.1996 14.37 16.4296 14.25C16.6596 14.11 16.8896 14.04 17.1396 14.04C17.3296 14.04 17.5296 14.08 17.7496 14.17C17.9696 14.26 18.1996 14.39 18.4496 14.56L21.7596 16.91C22.0196 17.09 22.1996 17.3 22.3096 17.55C22.4096 17.8 22.4696 18.05 22.4696 18.33Z" fill="currentColor" />
                    </svg>
                    +6285931194876
                  </a>
                </li>
                <li class="flex items-start gap-3 mb-4 text-base text-neutral-800 font-geist-mono">
                  <svg class="mt-1 shrink-0" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_footer_clock)">
                      <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM13 12V7H11V14H17V12H13Z" fill="currentColor" />
                    </g>
                    <defs>
                      <clipPath id="clip0_footer_clock">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <p>
                    Jam Kerja: <br>
                    (Senin-Jumat 9:00-17:00)
                  </p>
                </li>
              </ul>
            </div>

            <!-- Social Media -->
            <div>
              <h3 class="mb-4 text-xl font-medium text-neutral-800 font-geist">
                Sosial Media
              </h3>
              <div class="flex gap-[6px] items-center">
                <a
                  href="https://www.facebook.com/rintisanwaralaba"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-neutral-800 cursor-pointer"
                >
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.5 16.19C22.5 19.83 20.33 22 16.69 22H15.5C14.95 22 14.5 21.55 14.5 21V15.23C14.5 14.96 14.72 14.73 14.99 14.73L16.75 14.7C16.89 14.69 17.01 14.59 17.04 14.45L17.39 12.54C17.42 12.36 17.28 12.19 17.09 12.19L14.96 12.22C14.68 12.22 14.46 12 14.45 11.73L14.41 9.28C14.41 9.12 14.54 8.98001 14.71 8.98001L17.11 8.94C17.28 8.94 17.41 8.81001 17.41 8.64001L17.37 6.23999C17.37 6.06999 17.24 5.94 17.07 5.94L14.37 5.98001C12.71 6.01001 11.39 7.37 11.42 9.03L11.47 11.78C11.48 12.06 11.26 12.28 10.98 12.29L9.78 12.31C9.61 12.31 9.48001 12.44 9.48001 12.61L9.51001 14.51C9.51001 14.68 9.64 14.81 9.81 14.81L11.01 14.79C11.29 14.79 11.51 15.01 11.52 15.28L11.61 20.98C11.62 21.54 11.17 22 10.61 22H8.31C4.67 22 2.5 19.83 2.5 16.18V7.81C2.5 4.17 4.67 2 8.31 2H16.69C20.33 2 22.5 4.17 22.5 7.81V16.19Z" fill="currentColor" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/rintisan.waralaba/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-neutral-800"
                >
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.69 2H8.31C4.67 2 2.5 4.17 2.5 7.81V16.18C2.5 19.83 4.67 22 8.31 22H16.68C20.32 22 22.49 19.83 22.49 16.19V7.81C22.5 4.17 20.33 2 16.69 2ZM12.5 15.88C10.36 15.88 8.62 14.14 8.62 12C8.62 9.86 10.36 8.12 12.5 8.12C14.64 8.12 16.38 9.86 16.38 12C16.38 14.14 14.64 15.88 12.5 15.88ZM18.42 6.88C18.37 7 18.3 7.11 18.21 7.21C18.11 7.3 18 7.37 17.88 7.42C17.76 7.47 17.63 7.5 17.5 7.5C17.23 7.5 16.98 7.4 16.79 7.21C16.7 7.11 16.63 7 16.58 6.88C16.53 6.76 16.5 6.63 16.5 6.5C16.5 6.37 16.53 6.24 16.58 6.12C16.63 5.99 16.7 5.89 16.79 5.79C17.02 5.56 17.37 5.45 17.69 5.52C17.76 5.53 17.82 5.55 17.88 5.58C17.94 5.6 18 5.63 18.06 5.67C18.11 5.7 18.16 5.75 18.21 5.79C18.3 5.89 18.37 5.99 18.42 6.12C18.47 6.24 18.5 6.37 18.5 6.5C18.5 6.63 18.47 6.76 18.42 6.88Z" fill="currentColor" />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/rintisan/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-neutral-800"
                >
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5389 17.0433H14.5778V12.4022C14.5778 11.2956 14.5556 9.87111 13.0333 9.87111C11.49 9.87111 11.2544 11.0756 11.2544 12.3211V17.0433H8.29222V7.5H11.1367V8.8H11.1756C11.5733 8.05111 12.54 7.25889 13.9844 7.25889C16.9844 7.25889 17.54 9.23444 17.54 11.8044V17.0433H17.5389ZM4.94778 6.19444C4.72173 6.19474 4.49784 6.15041 4.28896 6.06401C4.08007 5.9776 3.8903 5.85082 3.73051 5.69093C3.57072 5.53104 3.44406 5.34118 3.35779 5.13224C3.27152 4.9233 3.22734 4.69938 3.22778 4.47333C3.228 4.13315 3.32909 3.80067 3.51827 3.51794C3.70745 3.23521 3.97622 3.01493 4.29059 2.88495C4.60496 2.75497 4.95082 2.72113 5.28442 2.78771C5.61803 2.85429 5.9244 3.01831 6.16479 3.25901C6.40518 3.49971 6.56879 3.80629 6.63494 4.13998C6.7011 4.47367 6.66681 4.81948 6.53643 5.13369C6.40604 5.44789 6.18541 5.71638 5.90243 5.90519C5.61946 6.094 5.28685 6.19466 4.94667 6.19444H4.94778ZM6.43222 17.0433H3.46222V7.5H6.43333V17.0433H6.43222ZM19.0222 0H1.97667C1.15889 0 0.5 0.644444 0.5 1.44111V18.5589C0.5 19.3556 1.16 20 1.97556 20H19.0178C19.8333 20 20.5 19.3556 20.5 18.5589V1.44111C20.5 0.644444 19.8333 0 19.0178 0H19.0211H19.0222Z" fill="currentColor" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full h-[1px] bg-neutral-200 mt-[60px] xs:mt-[40px]" />
      <p class="pb-10 mt-[30px] text-base text-neutral-800 font-geist-mono">
        © Copyright 2023 Rintisan.co.id All Rights Reserved.
      </p>
    </div>
  </footer>
</template>
